import styled from "styled-components";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";

const summaryOffset = 22;

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

export const Title = styled.h2`
    ${setFontVariant("subtitle1", colorsPalettes.carbon[500])};
`;

export const RadioContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const PaymentSummaryContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding-left: ${summaryOffset}px;
`;

export const Delimiter = styled.hr`
    border-color: ${colorsPalettes.carbon[50]};
    margin: 12px 0 8px ${summaryOffset}px;
`;

export const SummaryLineContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`;

export const DueTodayText = styled.span`
    ${setFontVariant("subtitle1", colorsPalettes.carbon[500])};
`;
